import PropTypes from 'prop-types';

// Props related to HTML <a> anchor link attributes.
const targetValues = ['_self', '_blank', '_parent', '_top'];
export default {
  types: {
    // React Native Web >= 0.15.0 supports hrefAttrs prop with only these properties
    // and passes them to <a> if an element has a href prop or accessibilityRole "link"
    download: PropTypes.string,
    rel: PropTypes.string,
    target: PropTypes.oneOf(targetValues)
  },
  /**
   * Takes a props object, bundles any hrefAttrs props present into one object
   * and returns that keyed as `hrefAttrs` and non-hrefAttrs props keyed as `rest`
   */
  bundle: _ref => {
    let {
      download,
      rel,
      target,
      ...rest
    } = _ref;
    return {
      hrefAttrs: {
        download,
        rel,
        target
      },
      rest
    };
  }
};